// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__ahEcm","textInfo":"Modal_textInfo__KfwPS","btnsWrap":"Modal_btnsWrap__XuFAQ","btn":"Modal_btn__fII-C"};